let getFormData = (o) => {
    let ret= new FormData();
    Object.keys(o).forEach(key=>ret.append(key, o[key]));
    return ret;
}
let ajax = (o, post=false) => fetch(
    gl_url_www
    + "www_base/redis_user.php?"
    + (post ? '' : Object.keys(o).map(key=>key+'='+encodeURIComponent(o[key])).join('&')),
    {
        method : post ? 'POST' : 'GET',
        headers : {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body : post ? getFormData(o) : undefined,
    }
)
.then(r=>r.json())
.then((r)=>{
    ret = r.find((data)=>data?.type?.toLowerCase?.()=='redisconfig');
    if (ret.error) throw ret.message ?? ret.error;
    if (ret.message) { console.info(ret.message); }
    return ret.data;
})


window.saveRedis=(app, modul, id, data)=>ajax({app, modul, id, type:"save", data}, true);
window.delRedis=(app, modul, id)=>ajax({app, modul, id, type:"delete"}, true);
window.loadRedis=(app, modul, id)=>ajax({app, modul, id});
